<template>
    <div id="demo-basic-card">
        <div id="dashboard-analytics" class="margin-top">
            <div class="vx-row">
                <div class="vx-col md:w-4/12 w-full mt-2 p-0" v-if="invoice.totalPayment">
                    <div class="vx-card bg-package p-12">
                        <div class="flex border-bottom-color w-full">
                            <div class="w-full">
                                <div class="vx-row ml-0">
                                    <div class="component w-full">
                                        <span class="sm:flex header-float m-auto font-regular">QUÝ KHÁCH CÓ 1 HOÁ ĐƠN CHƯA</span>
                                    </div>
                                    <div class="component w-full mb-4">
                                        <span class="sm:flex header-float m-auto font-regular">THANH TOÁN VỚI TỔNG SỐ TIỀN LÀ</span>
                                    </div>
                                    <div class="component w-full mb-4">
                                        <span class="sm:flex header-float m-auto font-medium" style="font-size:24px">{{ eArabic(invoice.totalPayment) || 0 }}đ</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="flex w-full mt-6">
                            <vs-button class="w-full mt-2 text-primary bg-white" @click="paymentInvoice">Thanh toán ngay</vs-button>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full mt-4 text-center">
                            <span class="font-medium">Cần sự trợ giúp? </span>
                            <span class="font-medium text-primary cursor-pointer">Liên hệ</span>
                        </div>
                    </div>
                </div>
                <div :class="{'vx-col md:w-8/12 w-full': invoice.totalPayment, 'vx-col w-full pl-0 pr-0': !invoice.totalPayment}">
                    <div class="vx-card w-full border-table">
                        <vs-table stripe :data="invoices" class="w-full mt-2">
                            <template>
                                <vs-tr>
                                    <vs-th class="fixed-header" v-for="(header, indexHeader) in headerTable " :key="indexHeader">
                                        <span>{{header.name}}</span>
                                    </vs-th>
                                </vs-tr>
                                <vs-tr v-for="(item, index) in invoices" :data="item" :key="index">
                                    <vs-td class="font-medium">#{{ item.code }}</vs-td>
                                    <vs-td>
                                        <div class="component w-full" v-for="(itemPackage, indexPackage) in businessPackages.filter(el => el.id == item.businessPackageId)" :key="indexPackage">
                                            <span class="font-medium">{{ itemPackage.name }}</span>
                                        </div>
                                        <div class="component w-full">
                                            <span class="text-sub-invoice">{{ item.time }}</span>
                                        </div>
                                    </vs-td>
                                    <vs-td>
                                        <span class="text-sub-invoice">{{ item.createdDate }}</span>
                                    </vs-td>
                                    <vs-td>
                                        <span class="text-sub-invoice">{{ item.expriredDate }}</span>
                                    </vs-td>
                                    <vs-td>
                                         <span
                                        class="badge"
                                        :style="{background: `rgba(var(--vs-${item.bg}),.12)`, color: `${item.color}`}">
                                        {{item.statusInvoice}}</span>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                    <div class="vx-card custom-card mt-2 w-full">
                        <div class="vx-col md:w-1/2 w-full m-auto ml-4">
                            <div class="component">
                                <span class="content-page">{{ $t('source.showing')}}: </span>
                                <span class="text-page">{{countElementPage > 0 ? currentPage :0}} - {{amount + countElementPage}}/{{totalElements}} </span>
                                <span class="content-page">{{ $t('source.content')}}</span>
                            </div>
                        </div>
                        <vs-pagination
                            class="custom-pagination"
                            :total ="totalPages"
                            :max="maxPageNumbers"
                            v-model="currentPage"
                        ></vs-pagination>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row">
            <iframe src="" frameborder="0"></iframe>
        </div>
    </div>
</template>
<script>
import moment from "moment";
export default {
    components: {

    },
    data(){
        return {
            checkStatus: false,
            totalPages: 0,
            maxPageNumbers: 6,
            currentPage: 1,
            countElementPage: 0,
            amount: 0,
            totalElements:0,
            invoices: [],
            headerTable: [
                {name: 'HOÁ ĐƠN SỐ'},
                {name: 'GÓI DỮ LIỆU'},
                {name: 'NGÀY TẠO HOÁ ĐƠN'},
                {name: 'HẠN THANH TOÁN'},
                {name: 'TÌNH TRẠNG'},
            ],
            businessPackages: [],
            days: null,
            invoice: {
                totalPayment: null,
                bankCode: "VNPAYQR",
                orderInfo: "Thanh toán đăng ký gói dịch vụ",
                orderType: "250000",
                billingFullName: 'Hoá đơn thanh toán',
                code: '',
                url: ''
            }
        }
    },
    methods:{
        paymentInvoice: function(){
            const payload = {
                amount: this.invoice.totalPayment,
                bankCode: this.invoice.bankCode,
                orderInfo: this.invoice.orderInfo,
                orderType: this.invoice.orderType,
                order_id: this.invoice.code,
                billingFullName: this.invoice.billingFullName
            }
            this.$business.post('user-package/vnpay-invoice', payload).then((response) => {
                let result = response.data.data;
                let index = result.indexOf('vnp_SecureHash');
                if (index > 0) this.invoice.url = result.slice(index).split('=').pop();
                window.open(response.data.data,'_blank')
            })
        },
        getInvoice: function(){
            const payload = {
                pageSize: 10,
                pageNumber: 0,
            }
            this.$business.post('user-package/get-all-invoice', payload).then((response) => {
                let invoice = response.data.content.filter(el => !el.status);
                this.invoice.totalPayment = invoice[0].totalPayment;
                this.invoice.code = invoice[0].code;
                this.countElementPage = response.data.content.slice(0, 10).length;
                this.amount = response.data.pageable.offset;
                this.getBusinessPackage();
                let result = response.data.content.map(el => {

                    this.countDateRange(el.createdDate, el.expiredDate);
                    if (this.days <= 30) el.time = "1 tháng";
                    if (30 < this.days <= 90) el.time = "3 tháng";
                    if (90 < this.days <= 365) el.time = "12 tháng";
                    el.createdDate = moment(el.createdDate).format('DD/MM/YYYY');
                    el.expriredDate = moment(el.expriredDate).format('DD/MM/YYYY');
                    if (el.status) {el.statusInvoice = "Đã thanh toán"; el.bg ="success"; el.color="#29CC97"};
                    if (!el.status) el.statusInvoice = "Chưa thanh toán"; el.bg ="danger"; el.color="#F12B2C";
                    return el;
                });
                this.invoices = result;
                this.totalPages = parseInt(response.data.totalPages,10);
                this.pagenumbers = response.data.pageable.pageNumber;
                this.totalElements = response.data.totalElements;
            })
        },
        getBusinessPackage: function(){
            this.$business.get('business-package/all').then((res) => {
                let result = res.data;
                result = result.map(el => {
                    if (el.name.includes('Gói khởi động')) el.name = "Starter - Gói khởi động";
                    if (el.name.includes('Gói cơ bản')) el.name = "Basic - Gói cơ bản";
                    if (el.name.includes('Gói nâng cao')) el.name = "Plus - Gói nâng cao";
                    if (el.name.includes('Gói chuyên nghiệp')) el.name = "Pro - Gói chuyên nghiệp";
                    if (el.name.includes('Gói cao cấp')) el.name = "Premium - Gói cao cấp";
                    return {
                        name: el.name,
                        price: el.price,
                        id: el.id,
                        bg: null
                    }
                })
                this.businessPackages = result;
            })
        },
        countDateRange: function(fromDate, toDate) {
            const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
            const firstDate = new Date(fromDate);
            const secondDate = new Date(toDate);
            const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
            this.days = diffDays;
        },
        eArabic: function(x) {
            return x.toLocaleString("de-DE");
        },
        initScreen(){
            this.getInvoice();
        }
    },
    async created(){
        this.initScreen();
    }
}
</script>
<style lang="scss">
.bg-package {
    background: #2f80ec;
    color: white;
}
.margin-top {
    margin-top: -24px;
}
.fixed-header{

}
.border-table .con-tablex .vs-con-tbody {
    border-radius: 5px 5px 0px 0px;
    z-index: 1;
}
.custom-card {
    height: 50px;
    display: flex !important;
    -webkit-box-shadow: 0px 4px 25px 0px rgb(0 0 0 / 2%) !important;
}
.border-bottom-color {
    border-bottom: 1px solid #D8D6DE;
    /* height: 35px; */
}
.text-page {
    font-size: 14px;
    color: #3ba1ff;
}
.content-page {
    color: #caccd6;
    font-size: 14px;
}
.badge {
    padding: .3rem .5rem;
    text-align: center;
    border-radius: .358rem;
    font-weight: 400 !important;
}
.text-sub-invoice{
    font-size: 12px;
    color: #B9B9C3;
}
</style>
